import React, { useEffect, useState } from 'react';
import { Button } from "react-bootstrap";
import { Formik, Form as FormikForm } from 'formik';
import { COLOR_WHITE, LINEAR_GRADIENT_BG } from '../../const';
import { useLazyQuery, useMutation } from '@apollo/client';
import { GET_CUSTOM_THEME } from '../../apollo/shop/Query';
import { UPDATE_CUSTOM_TEME } from '../../apollo/shop/mutation';
import { ReactIcons } from '../../icons';

export default function SettingCmScreen({ onCloseModal = () => { } }) {
    // State
    const [defaultData, setDefaultData] = useState({});

    // Apollo hooks
    const [getCustomTheme, { data: customThemeData, loading: loadingTheme }] = useLazyQuery(GET_CUSTOM_THEME, {
        fetchPolicy: 'network-only',
    });
    const [createCustomTheme, { loading: loadingCreateTheme }] = useMutation(UPDATE_CUSTOM_TEME);

    // Fetch custom theme on mount
    useEffect(() => {
        fetchCustomTheme();
    }, []);

    // Update state when new theme data is available
    useEffect(() => {
        if (customThemeData?.customTheme?.data) {
            setDefaultData(customThemeData?.customTheme?.data);
        }
    }, [customThemeData]);

    // Fetch custom theme
    const fetchCustomTheme = async () => {
        const shopData = JSON.parse(localStorage.getItem('SHOP_DATA'));
        if (loadingTheme || !shopData?.id) return;

        try {
            await getCustomTheme({
                variables: {
                    where: { shop: shopData.id },
                },
            });
        } catch (error) {
            console.error('Error fetching custom theme:', error);
        }
    };

    // Update custom theme
    const handleCustomThemeUpdate = async (values) => {
        const shopData = JSON.parse(localStorage.getItem('SHOP_DATA'));
        if (!shopData?.id || loadingCreateTheme) return;

        const themeData = {
            ...values,
            shop: shopData.id,
            id: defaultData?.id || undefined,
        };

        try {
            await createCustomTheme({
                variables: { data: themeData },
            });
            localStorage.setItem("CUSTOM_THEME_BY_SHOP", JSON.stringify({ datas: themeData }));

            fetchCustomTheme();
            onCloseModal()
        } catch (error) {
            console.error('Error updating custom theme:', error);
        }
    };
  

    const openSecondScreen = () => {
        if ("getScreenDetails" in window) {
          window.getScreenDetails().then((details) => {
            if (details.screens.length > 1) {
              const secondScreen = details.screens[1];
              const newWindow = window.open(
                "/customer_screen",
                "secondScreenWindow", // Set a specific name for the window
                `left=${secondScreen.availLeft},top=${secondScreen.availTop},width=${secondScreen.availWidth},height=${secondScreen.availHeight}`
              );
              if (!newWindow) {
                alert("Browser blocked the new window. Please allow pop-ups.");
              } else {
                localStorage.setItem(
                  "secondScreenWindowName",
                  "secondScreenWindow"
                );
                // setSecondScreenWindow(newWindow);
                newWindow.postMessage("FULLSCREEN", "*");
              }
            } else {
              const newWindow = window.open(
                "/customer_screen",
                "secondScreenWindow", // Set a specific name for the window
                "width=1366,height=768"
              );
              if (!newWindow) {
                alert("Browser blocked the new window. Please allow pop-ups.");
              } else {
                localStorage.setItem(
                  "secondScreenWindowName",
                  "secondScreenWindow"
                );
                // setSecondScreenWindow(newWindow);
                newWindow.postMessage("FULLSCREEN", "*");
              }
            }
          });
        } else {
          const newWindow = window.open(
            "/customer_screen",
            "secondScreenWindow", // Set a specific name for the window
            "width=1366,height=768"
          );
          if (!newWindow) {
            alert("Browser blocked the new window. Please allow pop-ups.");
          } else {
            localStorage.setItem("secondScreenWindowName", "secondScreenWindow");
            // setSecondScreenWindow(newWindow);
            newWindow.postMessage("FULLSCREEN", "*");
          }
        }
      };


    return (
        <div style={{ width: "100%", marginTop: '-2em' }}>
            <Formik
                enableReinitialize
                initialValues={{
                    isTitleCms: defaultData?.isTitleCms ?? false,
                    isBannerCms: defaultData?.isBannerCms ?? false,
                    // isTitleBannerCms: defaultData?.isTitleBannerCms ?? false,
                    isRateCms: defaultData?.isRateCms ?? false,
                    isTextMarqueeCms: defaultData?.isTextMarqueeCms ?? false,
                }}
                onSubmit={handleCustomThemeUpdate}
            >
                {({ values, handleChange, handleBlur }) => (
                    <FormikForm>
                        <Button
                            type="button"
                            variant="success"
                            className="mb-4 w-100 text-center"
                            // onClick={() => openCustomerPopup()}
                            onClick={(e) => openSecondScreen(e)}
                        >
                            <ReactIcons.BsDisplay style={{ fontSize: 34, marginBottom: 5 }} /> <br />
                            ຄຣິກເພື່ອເປີດຈໍ
                        </Button>

                        {/* Render fields */}
                        {[
                            { name: 'isTitleCms', label: 'ສະແດງຫົວຂໍ້' },
                            { name: 'isBannerCms', label: 'ສະແດງແບນເນີ' },
                            // { name: 'isTitleBannerCms', label: 'ສະແດງຫົວຂໍ້ແບນເນີ' },
                            { name: 'isRateCms', label: 'ເລດເງິນຂອງຮ້ານ' },
                            { name: 'isTextMarqueeCms', label: 'ສະແດງຍອດເງິນ' },
                        ].map(({ name, label }) => (
                            <div key={name} className="d-flex gap-3 my-4 justify-content-start align-items-center">
                                <input
                                    type="checkbox"
                                    name={name}
                                    checked={values[name]}
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    style={{ transform: 'scale(1.5)' }}
                                />
                                <label htmlFor={name}>{label}</label>
                            </div>
                        ))}

                        <div className="w-100 d-flex gap-3 my-4 justify-content-end mt-4">
                            <Button variant="outline-secondary" onClick={onCloseModal}>
                                ຍົກເລີກ
                            </Button>
                            <Button
                                type="submit"
                                variant="light"
                                disabled={loadingCreateTheme}
                                style={{
                                    background: LINEAR_GRADIENT_BG,
                                    color: COLOR_WHITE,
                                }}
                            >
                                {loadingCreateTheme ? 'ກຳລັງບັນທຶກ...' : 'ບັນທຶກ'}
                            </Button>
                        </div>
                    </FormikForm>
                )}
            </Formik>
        </div>
    );
}
